var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", staticClass: "analise", attrs: { tag: "div" } },
    [
      _vm.despachoAtual !== null
        ? _c(
            "div",
            { staticClass: "analise" },
            [
              _vm.despachoAtual.processo !== null
                ? _c(
                    "app-analise-header",
                    {
                      attrs: {
                        "id-processo": _vm.despachoAtual.processo.id,
                        idProcesso: _vm.isValidacao
                          ? parseInt(_vm.idProcesso)
                          : false,
                        "numero-processo":
                          _vm.despachoAtual.processo.numeroProcesso,
                        statusProcesso: _vm.despachoAtual.processo.status,
                        "titulo-analise": "Emissão de título",
                        tipo:
                          typeof _vm.despachoAtual.processo.tipo === "object"
                            ? _vm.despachoAtual.processo.tipo.codigo
                            : _vm.despachoAtual.processo.tipo,
                        numeroProtocolo:
                          _vm.despachoAtual.processo.numeroProtocolo,
                        "show-separate": true,
                        "show-messages": true,
                        opcoesHeader: true,
                        btnSolicitarInformacao: true,
                        idDespacho: _vm.despachoAtual.id
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "separate" },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "card-collapse",
                              attrs: { shadow: "hover" }
                            },
                            [
                              _c("app-despachos", {
                                attrs: {
                                  idProcesso: _vm.idProcesso,
                                  data: _vm.dadosCadastro
                                },
                                on: { getDownload: _vm.getDownload }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "analise" },
                        [
                          _c(
                            "el-steps",
                            {
                              staticClass: "extra-margin-top-bottom",
                              attrs: {
                                active: _vm.active,
                                "finish-status": "success",
                                simple: "simple"
                              }
                            },
                            [
                              _c("el-step", {
                                attrs: { title: "Confirmar dados" }
                              })
                            ],
                            1
                          ),
                          _vm.bytes
                            ? _c("app-pdf-slider", {
                                attrs: {
                                  documentosBytes: _vm.arrayBytes,
                                  primeiroDocumento: _vm.primeiroDocumento
                                },
                                on: { changePdfDownload: _vm.changePdfDownload }
                              })
                            : _vm._e(),
                          _vm.isRevisao
                            ? _c(
                                "div",
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                staticClass:
                                                  "input-text-editor",
                                                attrs: { label: "Despacho" }
                                              }),
                                              _c("app-editor-texto", {
                                                ref: "editorTexto",
                                                staticClass: "input",
                                                class: { erro: errors.length },
                                                on: {
                                                  onTextChange: _vm.onTextChange
                                                },
                                                model: {
                                                  value:
                                                    _vm.despachoAtual
                                                      .textoDespacho,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.despachoAtual,
                                                      "textoDespacho",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "despachoAtual.textoDespacho"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      400267599
                                    )
                                  }),
                                  _c("app-anexo", {
                                    attrs: {
                                      id: "upload-anexo-despacho",
                                      files: _vm.despachoAtual.documentos,
                                      tipoExibir: "ANEXO_ANALISE"
                                    },
                                    on: {
                                      uploadFile: _vm.uploadFile,
                                      removeFile: _vm.removeFile,
                                      downloadDocumentoCadastro:
                                        _vm.downloadDocumentoCadastro
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.acoesRadio.length > 0 &&
                          !_vm.isReurb &&
                          !_vm.isCertidao
                            ? _c(
                                "div",
                                { staticClass: "extra-margin-top" },
                                [
                                  _c(
                                    "validation-observer",
                                    {
                                      ref: "validationTitulo",
                                      staticClass: "flex-around",
                                      attrs: { tag: "div" }
                                    },
                                    [
                                      _c("app-radios-tramitacao", {
                                        attrs: {
                                          radios: _vm.acoesRadio,
                                          isDecisao: _vm.isDecisao,
                                          radioInicial: _vm.despachoAtual.acao
                                        },
                                        on: { changeRadio: _vm.changeRadio }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isValidacao && _vm.isCertidao
                            ? _c(
                                "div",
                                { staticClass: "flex extra-margin-top center" },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { border: "border", label: true },
                                      on: {
                                        change: function($event) {
                                          return _vm.alterarStatusTituloCertidao()
                                        }
                                      },
                                      model: {
                                        value: _vm.despachoAtual.validado,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.despachoAtual,
                                            "validado",
                                            $$v
                                          )
                                        },
                                        expression: "despachoAtual.validado"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.despachoAtual.validado
                                            ? "Validada"
                                            : "Marcar como conferida"
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "flex extra-margin-top" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn cancelBtn",
                                    attrs: { type: "default" },
                                    on: {
                                      click: function($event) {
                                        return _vm.cancelar()
                                      }
                                    }
                                  },
                                  [_vm._v("  Cancelar")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "default" },
                                    on: {
                                      click: function($event) {
                                        return _vm.downloadPdf()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v("Download PDF  "),
                                    _c("i", { staticClass: "fa fa-download" })
                                  ]
                                ),
                                _vm.isValidacao && !_vm.isRevisao
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "btn",
                                        attrs: { type: "default" },
                                        on: { click: _vm.editarTituloCertidao }
                                      },
                                      [
                                        _vm._v(
                                          "Editar " + _vm._s(_vm.titulo) + "  "
                                        ),
                                        _c("i", { staticClass: "fa fa-edit" })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isCertidao || _vm.isValidacao
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            "Existem certidões pendentes para validação",
                                          placement: "top",
                                          disabled: _vm.podeFinalizarTitulo
                                            ? true
                                            : false
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn",
                                            attrs: {
                                              type: "success",
                                              disabled:
                                                _vm.isValidacao &&
                                                _vm.isCertidao &&
                                                !_vm.podeFinalizarTitulo
                                                  ? true
                                                  : false
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.isValidacao &&
                                                !_vm.isCertidao
                                                  ? _vm.finalizar()
                                                  : _vm.confirmarDados()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v("Finalizar  "),
                                            _c("i", {
                                              staticClass: "fa fa-check"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b8d0874", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b8d0874","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/ConfirmarDadosCertidao.vue
// module id = null
// module chunks = 